import * as z from 'zod';

// PUT /3.0/users/refresh-access-token
export const UpdateAccessTokenResponse = z.object({
  accessToken: z.string(),
  accessTokenExpiresIn: z.string(), // ISO 8601形式の文字列
  refreshToken: z.string(),
  refreshTokenExpiresIn: z.string(), // ISO 8601形式の文字列
});
